<template>
  <v-row no-gutters>
    <v-col cols="12">
      <span>Vendor Name</span>
    </v-col>
    <v-col cols="12">
      <v-select
        id="ddlVendorId"
        v-model="activeStudentManagementVendorSid"
        :items="studentManagementVendors"
        item-title="name"
        item-value="sid"
        variant="solo"
        density="compact"
        placeholder="Select Vendor Name"
        clearable
        :disabled="isStudentManagementUnchangeable"
        clear-icon="mdi-close"
        color="primary"
        @update:model-value="changeStudentManagementVendorSid"
      >
        <template #item="data">
          <v-list-item
            v-bind="data.props"
            :id="`client-individual-modal--student-management-vendor--vendor-name--option-${String(
              data.item.name
            ).replaceAll(' ', '')}`"
          >
            {{ data.item.name }}
          </v-list-item>
        </template>
      </v-select>
    </v-col>
  </v-row>
</template>

<script>
import { CSBase } from '@complispace/cs-design-system';
import { mapGetters } from 'vuex';

export default {
  name: 'ClientContentEngine',

  extends: CSBase,

  props: {
    clientSid: {
      type: String,
      required: true,
      default: ''
    },
    studentManagementVendors: {
      type: Array,
      required: true
    },
    isStudentManagementUnchangeable: {
      type: Boolean,
      required: true
    }
  },

  emits: ['changeStudentManagementVendorSid'],

  data() {
    return {
      activeStudentManagementVendorSid: null
    };
  },

  computed: {
    ...mapGetters({
      clientStudentManagementView: 'clients/clientStudentManagementView'
    })
  },

  watch: {
    clientStudentManagementView() {
      this.reloadData();
    }
  },

  mounted() {
    this.initPage(this.clientSid);
  },

  methods: {
    async initPage(clientSid) {
      if (clientSid !== '') {
        await this.fetchClientStudentManagement();
        this.reloadData();
      }
    },

    async fetchClientStudentManagement() {
      try {
        if (this.clientSid) {
          this.setLoading(true);
          this.$store.dispatch('clients/fetchClientStudentManagement', this.clientSid);
          this.clearLoading();
        }
      } catch (e) {
        this.clearLoading();
      }
    },

    changeStudentManagementVendorSid() {
      this.$emit('changeStudentManagementVendorSid', this.activeStudentManagementVendorSid);
    },

    reloadData() {
      this.activeStudentManagementVendorSid =
        this.clientStudentManagementView?.studentVendorClientSid;
    }
  }
};
</script>
